module.exports = "/computer-illustratione83aadce6e8b3a2c4b0d5e1cdcdc67fa.svg";